import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgNoFilterHotelResults = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 166 99"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M72 32.657a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM96 32.657a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
      fill="#17181A"
    />
    <path d="M74 42.657s10.67-4 21 0" stroke="#17181A" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m10 16.657-5.878 3.09 1.123-6.545L.489 8.567l6.572-.955L10 1.657l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545L10 16.657ZM152 22.216l-8.652 4.441L145 17.25l-7-6.662 9.674-1.372L152 .657l4.326 8.559L166 10.588l-7 6.662 1.652 9.407L152 22.216ZM127.5 96.607l-4.017 2.05.767-4.342-3.25-3.074 4.491-.634 2.009-3.95 2.009 3.95 4.491.634-3.25 3.074.767 4.342-4.017-2.05Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M120.657 16.391 89.065 64.757v23.074l-6.517 2.56V88.82l2.517-.989V64.757l31.592-48.366h4Z"
      fill="#E1F3FF"
    />
    <path
      d="M83.048 65.757a.5.5 0 0 0-.09-.287l-33.34-47.579h70.115L88.646 65.484a.5.5 0 0 0-.081.273v22.734l-5.517 2.166v-24.9Z"
      stroke="#C2C5CC"
      strokeLinejoin="round"
    />
  </svg>
);
const Memo = memo(SvgNoFilterHotelResults);
export default Memo;
